import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from '@/components/Loading.vue';
let ImageWithLoading = class ImageWithLoading extends Vue {
    constructor() {
        super(...arguments);
        this.isError = false;
    }
    resetError() {
        this.isError = false;
    }
    handleError() {
        this.isError = true;
    }
};
__decorate([
    Watch('$route')
], ImageWithLoading.prototype, "resetError", null);
ImageWithLoading = __decorate([
    Component({
        components: {
            Loading
        }
    })
], ImageWithLoading);
export default ImageWithLoading;
